<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Create App</h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <customer-autocomplete
                label="Customer (optional)"
                id="autocustomer"
                placeholder=""
                :should-focus="false"
                v-model="customerDetails"
                :auto-fill-address="true"
                :update-customer="true"
                :allow-create-customer="false"
                version="v2"
            />
        </div>
        <div class="modal-footer">
            <md-button class="dialog-button md-primary" @click="handleSubmit">
                Submit
            </md-button>
            <md-button class="dialog-button md-default" @click.stop="$modal.hide">
                Cancel
            </md-button>
        </div>
    </div>
</template>
<script>
import { handleRequests, showErrorMessage } from '@/helpers';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { CustomerAutocomplete } from '@/components';
// eslint-disable-next-line import/no-dynamic-require
const { config } = require(`../../config/config.${process.env.NODE_ENV}`);

export default {
    name: 'CreateAppModal',
    mixins: [GeneralMixin],
    components: {
        CustomerAutocomplete
    },
    props: {
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            customerDetails: {
                customerId: null,
                contact: {
                    name: null
                }
            }
        };
    },
    methods: {
        async handleSubmit() {
            this.$_handleLoaderState(true, 'CREATING...');

            try {
                const payload = {
                    method: 'post',
                    data: {
                        customerId: this.customerDetails.customerId
                    }
                };

                const { data } = await handleRequests(`${config.authority}api/apps/create`, payload);

                const newApp = data;

                this.$_handleLoaderState(false);

                this.$messageBox
                    .show({
                        title: 'App Created',
                        body: `A new app has been created. The secret will not be displayed again, so please copy and save it :\n ${
                            newApp.clientSecret
                        }`,
                        buttons: ['Confirm']
                    })
                    .then(() => {
                        this.resolve(newApp);
                    });
            } catch (error) {
                this.$_handleLoaderState(false);
                const message = 'Error in creating app.';
                showErrorMessage(this, message, error);
            }
        }
    }
};
</script>
